import Wahanda from 'common/wahanda';
import { htmlToText } from 'common/dom-helpers';

import { getItemStatus } from './bookings-report';
import type { BookingsReportTableRow } from './bookings-report';

const escapeCsvCell = (value: string): string => {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const getStatusText = (item: BookingsReportTableRow): string => {
  const { badges } = getItemStatus(item);
  return badges
    .map((badge) =>
      badge.type === 'paymentProtection' ? Wahanda.lang.paymentProtection.badge.label : badge.text,
    )
    .join(', ');
};

const rowToCsvLine = (item: BookingsReportTableRow): string => {
  const dateInfo = Wahanda.Date.formatToDefaultFullDate(Wahanda.Date.parse(item.date));
  const dateStr = `${dateInfo.date} ${dateInfo.time}`;
  const value = item.value ? Wahanda.Currency.format(item.value as never) : '';
  const status = getStatusText(item);

  return [
    escapeCsvCell(htmlToText(item.orderRef)),
    escapeCsvCell(dateStr),
    escapeCsvCell(item.appointmentDatetime || ''),
    escapeCsvCell(item.employeeName || ''),
    escapeCsvCell(item.customer || ''),
    escapeCsvCell(item.service || ''),
    escapeCsvCell(value),
    escapeCsvCell(status),
  ].join(',');
};

export const downloadBookingsCsv = (
  rows: BookingsReportTableRow[],
  filename = 'bookings.csv',
): void => {
  const { headings } = Wahanda.lang.home.table;
  const headers = [
    headings.orderRef,
    headings.date,
    headings.appointmentDatetime,
    headings.employee,
    headings.customer,
    headings.service,
    headings.price,
    headings.status,
  ]
    .map(escapeCsvCell)
    .join(',');

  const lines = [headers, ...rows.map(rowToCsvLine)];
  const csvContent = lines.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
